const handleDeleteMaintenanceModal = {
  text1: '¿Realmente desea eliminar este Mantenimiento?',
  text2: 'ELIMINAR MANTENIMIENTO',
};

export default handleDeleteMaintenanceModal;
